'use client';

import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Css } from '@/ui';
import ParkingAvailabilityWidget from '../../parking-availability/ui/ParkingAvailabilityWidget';

export default function ParkingAvailabilitySection() {
	const [error, setError] = useState(false);

	if (error) {
		return null;
	}

	return (
		<ParkingWidgetWrap>
			<ParkingAvailabilityWidget onError={() => setError(true)} />
		</ParkingWidgetWrap>
	);
}

const ParkingWidgetWrap = styled.div`
	padding: ${Css.pxToRemFromTheme(24)} 0 0 0;
`;
